import { render, staticRenderFns } from "./qstournament.vue?vue&type=template&id=a59cf040&scoped=true"
import script from "./qstournament.vue?vue&type=script&lang=js"
export * from "./qstournament.vue?vue&type=script&lang=js"
import style0 from "./qstournament.vue?vue&type=style&index=0&id=a59cf040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59cf040",
  null
  
)

export default component.exports